import { render, staticRenderFns } from "./DataSourceValidate.vue?vue&type=template&id=399523d8&scoped=true&"
import script from "./DataSourceValidate.vue?vue&type=script&lang=js&"
export * from "./DataSourceValidate.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceValidate.vue?vue&type=style&index=0&id=399523d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399523d8",
  null
  
)

export default component.exports